var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"list",class:{ indent: _vm.indent }},_vm._l((_vm.nodes),function(node,index){return _c('node',{key:index,attrs:{"node":node}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }